import React from 'react';
import Header from '../../Shared/Header';
import BreadCums from '../../Shared/BreadCums';
import PricePlan from '../../Shared/PricePlan';
import PriceFaq from './PriceFaq';
import LatestBlog from '../../Shared/LatestBlog';
import Apps from '../../Shared/Apps';
import Footer3 from '../../Shared/Footer3';
import Home4Price from "../HomeFour/Home4Price";

const Price = () => {
    return (
        <>
            <Header
                parentMenu='pages'
                headerClass='sc-header-section inner-header-style'
                signUpBtn='inner-btn'
            />
            <BreadCums pageTitle='Pricing Plans' />
            {/*<PricePlan />*/}
           <Home4Price />
            <PriceFaq />{/*
            <LatestBlog />
            <Apps />*/}
            <Footer3 />
        </>
    );
};

export default Price;
